'use client'

import { useEffect, useRef, useState } from 'react'
import { useMarketplaceFavorites } from './MarketplaceFavoritesContext'
import { StarIcon } from '@radix-ui/react-icons'

type MarketplaceFavoritesButtonProps = {
  onClick: () => void
  landingPage?: boolean
  headerOpacity?: number
  showBounce?: boolean
}

export const MarketplaceFavoritesButton = ({
  onClick,
  landingPage = false,
  headerOpacity,
  showBounce = false,
}: MarketplaceFavoritesButtonProps) => {
  const { count } = useMarketplaceFavorites()
  const prevCountRef = useRef(count)
  const [isBouncing, setIsBouncing] = useState(false)

  useEffect(() => {
    if (showBounce && count > prevCountRef.current) {
      setIsBouncing(true)
      const timer = setTimeout(() => setIsBouncing(false), 400)
      prevCountRef.current = count
      return () => clearTimeout(timer)
    }
    prevCountRef.current = count
  }, [count, showBounce])

  const whiteIconOpacity =
    landingPage && headerOpacity !== undefined ? 1 - headerOpacity : 0
  const purpleIconOpacity = landingPage && headerOpacity !== undefined ? headerOpacity : 1

  return (
    <div className="relative h-[42px] w-[42px]">
      <button
        type="button"
        onClick={onClick}
        className="absolute inset-0 w-full h-full rounded-xl border border-white/45 flex justify-center items-center text-white transition-opacity duration-300"
        style={{ opacity: whiteIconOpacity }}
        aria-label="Open favorites"
      >
        <StarIcon className="h-5 w-5" />
      </button>
      <button
        type="button"
        onClick={onClick}
        className="absolute inset-0 w-full h-full rounded-xl border border-cw-purple-lighter flex justify-center items-center text-cw-midnight-purple transition-opacity duration-300 hover:border-cw-purple-lighter-hov"
        style={{ opacity: purpleIconOpacity }}
        aria-label="Open favorites"
      >
        <StarIcon className="h-5 w-5" />
      </button>
      {count > 0 && (
        <span
          className={`absolute -right-1 -top-1 min-w-[18px] rounded-full bg-cw-electric-purple px-1 text-center text-[11px] font-semibold leading-[18px] text-white ${
            isBouncing ? 'animate-badge-bounce' : ''
          }`}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </div>
  )
}
